import React from 'react';
import './TabletContainer.css';

interface TabletContainerProps {
  children: React.ReactNode;
  className?: string;
}

const TabletContainer: React.FC<TabletContainerProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`tablet-container ${className}`}>
      {children}
    </div>
  );
};

export default TabletContainer;